import { Theme } from '../../../../types/shared'
import {
  ChartEventBadgeState,
  IChartEventBadgeProps,
  getChartEventBadgeColors,
  getChartEventBageColors,
} from '../../../utils/chart-events-utils'

export function getChartEventEarningSvgString({
  theme = Theme.light,
  state = ChartEventBadgeState.default,
  width,
  isFuture = false,
}: IChartEventBadgeProps & { isFuture: boolean }) {
  const { outerStroke, innerStroke, innerFill, textFill } = getChartEventBadgeColors({
    theme,
    state,
    colors: getChartEventBageColors(isFuture ? 'purple' : 'gray'),
  })

  // browsers have issue rendering non-straight paths when one have same edge as other,
  // outer stroke line edge is same as inner fill edge and when browser rasterize diagonal line it breaks it down to pixels with variable opacity/color
  // but if there aren't opacity pixels on same place render is correct, due that adding fill solve incorrect color of colliding opacity pixels
  return `<svg
      xmlns="http://www.w3.org/2000/svg"
      width="${width}"
      height="${width}"
      viewBox="0 0 24 24"
    >
      <rect x="1.5" y="1.5" width="21" height="21" rx="3" stroke="${outerStroke}" fill="${outerStroke}" />
      <rect x="3" y="3" width="18" height="18" rx="2" fill="${innerFill}" />
      <rect x="3" y="3" width="18" height="18" rx="2" stroke="${innerStroke}" fill="transparent" stroke-width="2" />
      <path d="M8.96 16V7.27h5.47v1.14h-4.15v2.66h3.86v1.12h-3.86v2.68h4.2V16H8.96Z" fill="${textFill}" />
    </svg>`
}
